import { IonButton, IonCheckbox, IonContent, IonHeader, IonItem, IonList, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { IonButtons } from '@ionic/react';
import { FlapState } from '../../models/FrameMetadata';
import styles from '../DoorPolicyModal.module.css';
import { useState } from 'react';
import { useCommonTranslation, useModalTranslation } from '../../hooks/useTranslation';
import { getFlapStateLabel } from '../../utils/doorPolicyTranslations';

export interface EditDoorPolicyFlapStatePickerProps {
    flapStates: FlapState[];
    onSelectFlapStates: (states: FlapState[]) => void;
    onClose: () => void;
}

const EditDoorPolicyFlapStatePicker = ({
    flapStates,
    onSelectFlapStates,
    onClose,
}: EditDoorPolicyFlapStatePickerProps) => {
    const [selectedStates, setSelectedStates] = useState(flapStates);
    const { t: tCommon } = useCommonTranslation();
    const { t: tModals } = useModalTranslation();
    const stateOptions = Object.entries(FlapState)
        .filter((entry) => typeof entry[1] === 'number' && Number(entry[1]) >= 0)
        .map(([label, value]) => ({
            label: getFlapStateLabel(tModals, value as FlapState),
            value: value as FlapState,
        }));
    const toggleState = (value: FlapState) => {
        if (selectedStates.includes(value)) {
            setSelectedStates(selectedStates.filter((state) => state !== value));
        } else {
            setSelectedStates([...selectedStates, value]);
        }
    };

    return (
        <IonPage>
            <IonHeader translucent>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={onClose}>
                            {tCommon('buttons.cancel')}
                        </IonButton>
                    </IonButtons>
                    {/* ios title mode keeps the title centered in md too */}
                    <IonTitle {...({ mode: 'ios' } as object)}>{tModals('door_policy.pickers.flap_state.title')}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton
                            strong={true}
                            onClick={() => {
                                onSelectFlapStates(selectedStates);
                                onClose();
                            }}
                        >
                            {tCommon('buttons.save')}
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen color="light">
                <section className={`${styles.wrapper} ${styles.section}`}>
                    <h2 className={styles.sectionLabel}>{tModals('door_policy.pickers.flap_state.heading')}</h2>
                    <IonList className={styles.listCard}>
                        {stateOptions.map((option) => {
                            const isSelected = selectedStates.includes(option.value);
                            return (
                                <IonItem
                                    key={option.value}
                                    button
                                    detail={false}
                                >
                                    <IonCheckbox
                                        checked={isSelected}
                                        onIonChange={() => {
                                            toggleState(option.value);
                                        }}
                                    >
                                        {option.label}
                                    </IonCheckbox>
                                </IonItem>
                            );
                        })}
                    </IonList>
                </section>
            </IonContent>
        </IonPage>
    );
};

export const EditDoorPolicyFlapStatePickerView = (props: EditDoorPolicyFlapStatePickerProps) => (
    <EditDoorPolicyFlapStatePicker {...props} />
);

export default EditDoorPolicyFlapStatePicker;
